import Vue from 'vue';
import { Module } from 'vuex';
import { RootState } from '@/types/store';
import { ParticipationCertificateModel } from '../model/participationCertificate';

export interface ParticipationCertificatesState {
    activityList: ListWrap<number> & ListReq;
    activityMap: {
        [activityId: number]: ParticipationCertificateModel;
    };
    activityDetailMap: {
        [activityId: number]: ParticipationCertificateModel;
    };
    /** 证书列表 */
    activityCertificates: {
        [activityId: string]: ParticipationCertificates.CertItem[];
    };
}

const m: Module<ParticipationCertificatesState, RootState> = {
    namespaced: true,
    state: () => ({
        activityList: {
            list: [],
            loaded: false,
            req: false,
        },
        activityMap: {},
        activityDetailMap: {},
        activityCertificates: {},
    }),
    mutations: {
        concatActivityList(state, { key, list }) {
            const ids: number[] = [];
            (list || []).forEach((item: ParticipationCertificates.ActivityList) => {
                Vue.set(state.activityMap, item.activity_id, new ParticipationCertificateModel(item));
                ids.push(item.activity_id);
            });
            state.activityList.list = state.activityList.list.concat(ids);
        },
        setActivityListLoaded(state, { key, loaded }) {
            state.activityList.loaded = loaded;
        },
        setActivityListReq(state, { key, req }) {
            state.activityList.req = req;
        },
        setActivityCertificates(state, { activityId, data }) {
            Vue.set(state.activityCertificates, activityId, data);
        },
        setActivityCertificateDetail(state, { activityId, data }) {
            Vue.set(state.activityDetailMap, activityId, new ParticipationCertificateModel(data));
        },
    },
    actions: {
        /**
         * 获取活动列表
         */
        async getActivityList({ state, commit }, { offset, count }) {
            const wrap = state.activityList;
            if (wrap.req || wrap.loaded) {
                return;
            }
            const end = offset + count;
            const len = wrap.list.length;
            if (end <= len) {
                return;
            }
            if (offset < len) {
                offset = len;
                count = end - offset;
            }
            commit('setActivityListReq', { req: true });
            const response = await Vue.axios.get('/api/v1/participation_certificates/activity_list', {
                params: {
                    offset,
                    count,
                },
            });
            const rdata = response.data;
            if (rdata.status === 0) {
                const list = rdata.data;
                commit('concatActivityList', { list });
                if (list.length < count) {
                    commit('setActivityListLoaded', { loaded: true });
                }
            }
            commit('setActivityListReq', { req: false });
            return rdata;
        },
        async getActivityCertificates({ state, commit }, { activityId }: { activityId: string}) {
            const response = await Vue.axios.get('/api/v1/participation_certificates/list', {
                params: {
                    activity_id: activityId,
                },
            });
            const rdata = response.data;
            if (rdata.status === 0) {
                commit('setActivityCertificates', {
                    activityId,
                    data: rdata.data,
                });
            }
            return rdata;
        },
        /** 获取活动详情 */
        async getActivityCertificatesDetail({ state, commit }, { activityId }: { activityId: string}) {
            const response = await Vue.axios.get('/api/v1/participation_certificates/activity_detail', {
                params: {
                    activity_id: activityId,
                },
            });
            const rdata = response.data;
            if (rdata.status === 0) {
                commit('setActivityCertificateDetail', {
                    activityId,
                    data: rdata.data,
                });
            }
            return rdata;
        },
        /**
         * 重新生成证书
         */
        async regenerate({ state, commit, dispatch }, { activityId, name }: { activityId: string, name: string }) {
            const response = await Vue.axios.post('/api/v1/participation_certificates/regenerate', {
                activity_id: activityId,
                name,
            });
            const rdata = response.data;
            return rdata;
        },
    },
};
export default m;
